"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getErrorType;
/**
 * Returns a graphql error type or undefined
 * @param {error} error
 * @return {Object | void}
 */

function getErrorType(error) {
  return error && error.graphQLErrors.length && error.graphQLErrors[0].extensions.code;
}